import GB from '@/assets/flags/GB.svg'
import ID from '@/assets/flags/ID.svg'
import MY from '@/assets/flags/MY.svg'
import PH from '@/assets/flags/PH.svg'
import SG from '@/assets/flags/SG.svg'
import TH from '@/assets/flags/TH.svg'
import US from '@/assets/flags/US.svg'
import VN from '@/assets/flags/VN.svg'
import IT from '@/assets/flags/IT.svg'
import TR from '@/assets/flags/TR.svg'
import CN from '@/assets/flags/CN.svg'
import AR from '@/assets/flags/AR.svg'
import GLOBAL from '@/assets/flags/globe.svg'
import BR from '@/assets/flags/BR.svg'
import KR from '@/assets/flags/KR.svg'
import QA from '@/assets/flags/QA.svg'
import AD from '@/assets/flags/AD.svg'
import AE from '@/assets/flags/AE.svg'
import AF from '@/assets/flags/AF.svg'
import AG from '@/assets/flags/AG.svg'
import AL from '@/assets/flags/AL.svg'
import AM from '@/assets/flags/AM.svg'
import AO from '@/assets/flags/AO.svg'
import AT from '@/assets/flags/AT.svg'
import AU from '@/assets/flags/AU.svg'
import AZ from '@/assets/flags/AZ.svg'
import BA from '@/assets/flags/BA.svg'
import BB from '@/assets/flags/BB.svg'
import BD from '@/assets/flags/BD.svg'
import BE from '@/assets/flags/BE.svg'
import BF from '@/assets/flags/BF.svg'
import BG from '@/assets/flags/BG.svg'
import BH from '@/assets/flags/BH.svg'
import BI from '@/assets/flags/BI.svg'
import BJ from '@/assets/flags/BJ.svg'
import BN from '@/assets/flags/BN.svg'
import BO from '@/assets/flags/BO.svg'
import BS from '@/assets/flags/BS.svg'
import BT from '@/assets/flags/BT.svg'
import BW from '@/assets/flags/BW.svg'
import BY from '@/assets/flags/BY.svg'
import BZ from '@/assets/flags/BZ.svg'
import CA from '@/assets/flags/CA.svg'
import CD from '@/assets/flags/CD.svg'
import CF from '@/assets/flags/CF.svg'
import CG from '@/assets/flags/CG.svg'
import CH from '@/assets/flags/CH.svg'
import CI from '@/assets/flags/CI.svg'
import CL from '@/assets/flags/CL.svg'
import CM from '@/assets/flags/CM.svg'
import CO from '@/assets/flags/CO.svg'
import CR from '@/assets/flags/CR.svg'
import CU from '@/assets/flags/CU.svg'
import CV from '@/assets/flags/CV.svg'
import CY from '@/assets/flags/CY.svg'
import CZ from '@/assets/flags/CZ.svg'
import DE from '@/assets/flags/DE.svg'
import DJ from '@/assets/flags/DJ.svg'
import DK from '@/assets/flags/DK.svg'
import DM from '@/assets/flags/DM.svg'
import DO from '@/assets/flags/DO.svg'
import DZ from '@/assets/flags/DZ.svg'
import EC from '@/assets/flags/EC.svg'
import EE from '@/assets/flags/EE.svg'
import EG from '@/assets/flags/EG.svg'
import ER from '@/assets/flags/ER.svg'
import ES from '@/assets/flags/ES.svg'
import ET from '@/assets/flags/ET.svg'
import FI from '@/assets/flags/FI.svg'
import FJ from '@/assets/flags/FJ.svg'
import FM from '@/assets/flags/FM.svg'
import FR from '@/assets/flags/FR.svg'
import GA from '@/assets/flags/GA.svg'
import GD from '@/assets/flags/GD.svg'
import GE from '@/assets/flags/GE.svg'
import GH from '@/assets/flags/GH.svg'
import GM from '@/assets/flags/GM.svg'
import GN from '@/assets/flags/GN.svg'
import GQ from '@/assets/flags/GQ.svg'
import GR from '@/assets/flags/GR.svg'
import GT from '@/assets/flags/GT.svg'
import GW from '@/assets/flags/GW.svg'
import GY from '@/assets/flags/GY.svg'
import HK from '@/assets/flags/HK.svg'
import HN from '@/assets/flags/HN.svg'
import HR from '@/assets/flags/HR.svg'
import HT from '@/assets/flags/HT.svg'
import HU from '@/assets/flags/HU.svg'
import IE from '@/assets/flags/IE.svg'
import IL from '@/assets/flags/IL.svg'
import IN from '@/assets/flags/IN.svg'
import IQ from '@/assets/flags/IQ.svg'
import IR from '@/assets/flags/IR.svg'
import IS from '@/assets/flags/IS.svg'
import JM from '@/assets/flags/JM.svg'
import JO from '@/assets/flags/JO.svg'
import JP from '@/assets/flags/JP.svg'
import KE from '@/assets/flags/KE.svg'
import KG from '@/assets/flags/KG.svg'
import KH from '@/assets/flags/KH.svg'
import KI from '@/assets/flags/KI.svg'
import KM from '@/assets/flags/KM.svg'
import KN from '@/assets/flags/KN.svg'
import KP from '@/assets/flags/KP.svg'
import KW from '@/assets/flags/KW.svg'
import KZ from '@/assets/flags/KZ.svg'
import LA from '@/assets/flags/LA.svg'
import LB from '@/assets/flags/LB.svg'
import LC from '@/assets/flags/LC.svg'
import LI from '@/assets/flags/LI.svg'
import LK from '@/assets/flags/LK.svg'
import LR from '@/assets/flags/LR.svg'
import LS from '@/assets/flags/LS.svg'
import LT from '@/assets/flags/LT.svg'
import LU from '@/assets/flags/LU.svg'
import LV from '@/assets/flags/LV.svg'
import LY from '@/assets/flags/LY.svg'
import MA from '@/assets/flags/MA.svg'
import MC from '@/assets/flags/MC.svg'
import MD from '@/assets/flags/MD.svg'
import ME from '@/assets/flags/ME.svg'
import MG from '@/assets/flags/MG.svg'
import MH from '@/assets/flags/MH.svg'
import MK from '@/assets/flags/MK.svg'
import ML from '@/assets/flags/ML.svg'
import MM from '@/assets/flags/MM.svg'
import MN from '@/assets/flags/MN.svg'
import MO from '@/assets/flags/MO.svg'
import MR from '@/assets/flags/MR.svg'
import MT from '@/assets/flags/MT.svg'
import MU from '@/assets/flags/MU.svg'
import MV from '@/assets/flags/MV.svg'
import MW from '@/assets/flags/MW.svg'
import MX from '@/assets/flags/MX.svg'
import MZ from '@/assets/flags/MZ.svg'
import NA from '@/assets/flags/NA.svg'
import NE from '@/assets/flags/NE.svg'
import NG from '@/assets/flags/NG.svg'
import NI from '@/assets/flags/NI.svg'
import NL from '@/assets/flags/NL.svg'
import NP from '@/assets/flags/NP.svg'
import NR from '@/assets/flags/NR.svg'
import NZ from '@/assets/flags/NZ.svg'
import OM from '@/assets/flags/OM.svg'
import PA from '@/assets/flags/PA.svg'
import PE from '@/assets/flags/PE.svg'
import PG from '@/assets/flags/PG.svg'
import PK from '@/assets/flags/PK.svg'
import PL from '@/assets/flags/PL.svg'
import PS from '@/assets/flags/PS.svg'
import PT from '@/assets/flags/PT.svg'
import PW from '@/assets/flags/PW.svg'
import PY from '@/assets/flags/PY.svg'
import RO from '@/assets/flags/RO.svg'
import RS from '@/assets/flags/RS.svg'
import RU from '@/assets/flags/RU.svg'
import RW from '@/assets/flags/RW.svg'
import SA from '@/assets/flags/SA.svg'
import SB from '@/assets/flags/SB.svg'
import SC from '@/assets/flags/SC.svg'
import SD from '@/assets/flags/SD.svg'
import SE from '@/assets/flags/SE.svg'
import SI from '@/assets/flags/SI.svg'
import SK from '@/assets/flags/SK.svg'
import SL from '@/assets/flags/SL.svg'
import SM from '@/assets/flags/SM.svg'
import SN from '@/assets/flags/SN.svg'
import SO from '@/assets/flags/SO.svg'
import SR from '@/assets/flags/SR.svg'
import SS from '@/assets/flags/SS.svg'
import ST from '@/assets/flags/ST.svg'
import SV from '@/assets/flags/SV.svg'
import SY from '@/assets/flags/SY.svg'
import SZ from '@/assets/flags/SZ.svg'
import TD from '@/assets/flags/TD.svg'
import TG from '@/assets/flags/TG.svg'
import TJ from '@/assets/flags/TJ.svg'
import TL from '@/assets/flags/TL.svg'
import TM from '@/assets/flags/TM.svg'
import TN from '@/assets/flags/TN.svg'
import TO from '@/assets/flags/TO.svg'
import TT from '@/assets/flags/TT.svg'
import TV from '@/assets/flags/TV.svg'
import TW from '@/assets/flags/TW.svg'
import TZ from '@/assets/flags/TZ.svg'
import UA from '@/assets/flags/UA.svg'
import UG from '@/assets/flags/UG.svg'
// import UK from '@/assets/flags/UK.svg'
import UY from '@/assets/flags/UY.svg'
import UZ from '@/assets/flags/UZ.svg'
import VA from '@/assets/flags/VA.svg'
import VC from '@/assets/flags/VC.svg'
import VE from '@/assets/flags/VE.svg'
import VU from '@/assets/flags/VU.svg'
import WS from '@/assets/flags/WS.svg'
import YE from '@/assets/flags/YE.svg'
import ZA from '@/assets/flags/ZA.svg'
import ZM from '@/assets/flags/VC.svg'
import ZW from '@/assets/flags/VC.svg'

export default {
  GB,
  ID,
  MY,
  PH,
  SG,
  TH,
  US,
  VN,
  IT,
  TR,
  CN,
  AR,
  GLOBAL,
  BR,
  KR,
  QA,
  AD,
  AE,
  AF,
  AG,
  AL,
  AM,
  AO,
  AT,
  AU,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BN,
  BO,
  BS,
  BT,
  BW,
  BY,
  BZ,
  CA,
  CD,
  CF,
  CG,
  CH,
  CI,
  CL,
  CM,
  CO,
  CR,
  CU,
  CV,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FM,
  FR,
  GA,
  GD,
  GE,
  GH,
  GM,
  GN,
  GQ,
  GR,
  GT,
  GW,
  GY,
  HK,
  HN,
  HR,
  HT,
  HU,
  IE,
  IL,
  IN,
  IQ,
  IR,
  IS,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KN,
  KP,
  KW,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  ME,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MO,
  MR,
  MT,
  MU,
  MV,
  MW,
  MX,
  MZ,
  NA,
  NE,
  NG,
  NI,
  NL,
  NP,
  NR,
  NZ,
  OM,
  PA,
  PE,
  PG,
  PK,
  PL,
  PS,
  PT,
  PW,
  PY,
  RO,
  RS,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SI,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  SS,
  ST,
  SV,
  SY,
  SZ,
  TD,
  TG,
  TJ,
  TL,
  TM,
  TN,
  TO,
  TT,
  TV,
  TW,
  TZ,
  UA,
  UG,
  // UK,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VU,
  WS,
  YE,
  ZA,
  ZM,
  ZW
}
